// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/svg/leftBannerSplash.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/about-us-consultation-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_header__6wRnA {
    height: 280px;
    display: flex;
    padding: 10px 0px 40px 0px;
    text-align: center;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    position: relative;
}

.style_header__6wRnA::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: -100px;
    right: -88%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    z-index: -1;
}

.style_header__6wRnA::after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: -320px;
    left: -11%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    z-index: -1;
}

.style_header__6wRnA h2,
.style_header__6wRnA p {
    width: auto;
    max-width: 794px;
}

.style_header__6wRnA h2 {
    margin-bottom: 15px;
}

.style_header__6wRnA p {
    margin-bottom: 9px;
}

.style_vision__deets__9RoxI {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    position: relative;
}

.style_vision__deets__9RoxI>div {
    width: 85%;
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 5%;
    padding-bottom: 50px;
    border-bottom: 1px solid #ECECEC
}

.style_vision__deets__9RoxI .style_vision__deets_text__y2NDZ {
    width: 48%;
    max-width: 658px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.style_vision__deets__9RoxI .style_vision__deets_text__y2NDZ p {
    font-size: 14px;
    margin-top: 8px;
}

.style_vision__deets__9RoxI .style_vision__deets_text__y2NDZ h4 {
    font-size: 28px;
    color: var(--primary-01);
    margin-bottom: 0px;
}

.style_vision__deets__9RoxI .style_vision__deets_image__s-T94 {
    width: 40%;
    height: inherit;
    max-width: 454px;
    border-radius: 12px;
}

.style_vision__deets__9RoxI .style_vision__deets_image__s-T94 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
}

.style_our__team__oI5Bc {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 40px 0px;
    justify-content: flex-end;
    background-color: var(--grey-06);
    border: 1px solid;
}

.style_our__team__oI5Bc h4 {
    font-size: 32px;
}

.style_our__team__oI5Bc h4,
.style_our__team__oI5Bc p {
    max-width: 794px;
    margin: 0px 0px 20px 0px;
    color: var(--white);
}

.style_our__team_wrapper__z8q9r {
    width: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.style_our__team_slider_container__xRnbw {
    width: 100%;
    overflow-x: scroll;
    height: inherit;
}

.style_our__team_slider__GDgK1 {
    width: auto;
    height: inherit;
    display: flex;
    gap: 20px;
}

/*Consult */
.style_book_consult__XAvHY {
    width: 100%;
    height: 350px;
    display: flex;
    text-align: center;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: right;
    padding: 20px 0px 25px 0px;
}

.style_book_consult__XAvHY h3,
.style_book_consult__XAvHY p {
    width: 90%;
    max-width: 673px;
}

.style_book_consult__XAvHY h3 {
    font-size: 36px;
    margin-bottom: 10px;
}

.style_book_consult__XAvHY p {
    margin-bottom: 20px;
}

@media (max-width: 768px) {
    .style_header__6wRnA {
        height: auto;
        padding: 10px 0px 0px 0px;
    }

    .style_header__6wRnA::after {
        left: -128px;
    }

    header p,
    header h2 {
        width: 93% !important;
    }

    .style_vision__deets_strip_ltr__GHp03 {
        flex-direction: column !important;
    }

    .style_vision__deets_strip_rtl__4h1CP {
        flex-direction: column-reverse !important;
    }

    .style_vision__deets__9RoxI>div {
        width: 90%;
    }

    .style_vision__deets_text__y2NDZ p {
        margin-bottom: 50px;
    }

    .style_vision__deets_text__y2NDZ,
    .style_vision__deets_image__s-T94 {
        width: 100% !important;
    }

    .style_our__team_slider__GDgK1 {
        display: grid;
        grid-template-rows: auto auto;
        grid-auto-flow: column;
        overflow-x: scroll;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/about-us/style.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yDAA4D;IAC5D,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,yDAA4D;IAC5D,4BAA4B;IAC5B,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,OAAO;IACP,oBAAoB;IACpB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;IACb,SAAS;AACb;;AAEA,WAAW;AACX;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,yDAA+E;IAC/E,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;;IAEI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,YAAY;IAChB;;IAEA;;QAEI,qBAAqB;IACzB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,yCAAyC;IAC7C;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,6BAA6B;QAC7B,sBAAsB;QACtB,kBAAkB;IACtB;;AAEJ","sourcesContent":[".header {\n    height: 280px;\n    display: flex;\n    padding: 10px 0px 40px 0px;\n    text-align: center;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n}\n\n.header::before {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: -100px;\n    right: -88%;\n    background-image: url(../../assets/svg/leftBannerSplash.svg);\n    background-repeat: no-repeat;\n    z-index: -1;\n}\n\n.header::after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    bottom: -320px;\n    left: -11%;\n    background-image: url(../../assets/svg/leftBannerSplash.svg);\n    background-repeat: no-repeat;\n    z-index: -1;\n}\n\n.header h2,\n.header p {\n    width: auto;\n    max-width: 794px;\n}\n\n.header h2 {\n    margin-bottom: 15px;\n}\n\n.header p {\n    margin-bottom: 9px;\n}\n\n.vision__deets {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 50px;\n    position: relative;\n}\n\n.vision__deets>div {\n    width: 85%;\n    max-width: 1200px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    gap: 5%;\n    padding-bottom: 50px;\n    border-bottom: 1px solid #ECECEC\n}\n\n.vision__deets .vision__deets_text {\n    width: 48%;\n    max-width: 658px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.vision__deets .vision__deets_text p {\n    font-size: 14px;\n    margin-top: 8px;\n}\n\n.vision__deets .vision__deets_text h4 {\n    font-size: 28px;\n    color: var(--primary-01);\n    margin-bottom: 0px;\n}\n\n.vision__deets .vision__deets_image {\n    width: 40%;\n    height: inherit;\n    max-width: 454px;\n    border-radius: 12px;\n}\n\n.vision__deets .vision__deets_image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 12px;\n}\n\n.our__team {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    padding: 40px 0px;\n    justify-content: flex-end;\n    background-color: var(--grey-06);\n    border: 1px solid;\n}\n\n.our__team h4 {\n    font-size: 32px;\n}\n\n.our__team h4,\n.our__team p {\n    max-width: 794px;\n    margin: 0px 0px 20px 0px;\n    color: var(--white);\n}\n\n.our__team_wrapper {\n    width: 90%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n}\n\n.our__team_slider_container {\n    width: 100%;\n    overflow-x: scroll;\n    height: inherit;\n}\n\n.our__team_slider {\n    width: auto;\n    height: inherit;\n    display: flex;\n    gap: 20px;\n}\n\n/*Consult */\n.book_consult {\n    width: 100%;\n    height: 350px;\n    display: flex;\n    text-align: center;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    background-image: url(../../assets/images/about-us-consultation-background.png);\n    background-position: right;\n    padding: 20px 0px 25px 0px;\n}\n\n.book_consult h3,\n.book_consult p {\n    width: 90%;\n    max-width: 673px;\n}\n\n.book_consult h3 {\n    font-size: 36px;\n    margin-bottom: 10px;\n}\n\n.book_consult p {\n    margin-bottom: 20px;\n}\n\n@media (max-width: 768px) {\n    .header {\n        height: auto;\n        padding: 10px 0px 0px 0px;\n    }\n\n    .header::after {\n        left: -128px;\n    }\n\n    header p,\n    header h2 {\n        width: 93% !important;\n    }\n\n    .vision__deets_strip_ltr {\n        flex-direction: column !important;\n    }\n\n    .vision__deets_strip_rtl {\n        flex-direction: column-reverse !important;\n    }\n\n    .vision__deets>div {\n        width: 90%;\n    }\n\n    .vision__deets_text p {\n        margin-bottom: 50px;\n    }\n\n    .vision__deets_text,\n    .vision__deets_image {\n        width: 100% !important;\n    }\n\n    .our__team_slider {\n        display: grid;\n        grid-template-rows: auto auto;\n        grid-auto-flow: column;\n        overflow-x: scroll;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `style_header__6wRnA`,
	"vision__deets": `style_vision__deets__9RoxI`,
	"vision__deets_text": `style_vision__deets_text__y2NDZ`,
	"vision__deets_image": `style_vision__deets_image__s-T94`,
	"our__team": `style_our__team__oI5Bc`,
	"our__team_wrapper": `style_our__team_wrapper__z8q9r`,
	"our__team_slider_container": `style_our__team_slider_container__xRnbw`,
	"our__team_slider": `style_our__team_slider__GDgK1`,
	"book_consult": `style_book_consult__XAvHY`,
	"vision__deets_strip_ltr": `style_vision__deets_strip_ltr__GHp03`,
	"vision__deets_strip_rtl": `style_vision__deets_strip_rtl__4h1CP`
};
export default ___CSS_LOADER_EXPORT___;
